import "../styles/Status.css";
import { useTranslation } from '../context/TranslationContext';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { FiFileText, FiHelpCircle, FiSearch, FiUser } from "react-icons/fi";
import { useFeatureFlags } from "../context/FeatureFlagsContext";
import {
  GLOBAL_SEARCH_PATH,
  canUseAdvancedClientSearch,
  canUseCoordinatorGlobalSearch,
  getLegacySearchPath,
} from "../helpers/globalSearchHelper";
import NotificationBell from "./NotificationBell";

const Status = () => {
  const { t, changeLanguage, language } = useTranslation();
  const navigate = useNavigate();
  const { isLoggedIn, signOut, loading, user } = useAuth();
  const { features } = useFeatureFlags();
  const globalSearchEnabled = canUseCoordinatorGlobalSearch(features, user);
  // CoCos never get the GLOBAL search; their magnifier opens the legacy search page,
  // which links to the advanced search.
  const coordinatorAdvancedOnly = !globalSearchEnabled
    && canUseAdvancedClientSearch(features)
    && user?.capabilities?.canAccessCoordinator === true;
  const searchLabel = t(
    globalSearchEnabled || coordinatorAdvancedOnly
      ? "breadcrumb.globalSearch"
      : features.clientSearch ? "breadcrumb.clientSearch" : "breadcrumb.cpfSearch",
  );

  const wasLoggedIn = localStorage.getItem("wasLoggedIn") === "true";
  const showLoggedIn = isLoggedIn || (loading && wasLoggedIn);

  const toggleLanguage = () => {
    changeLanguage(language === "en" ? "pt" : "en");
  };

  const handleSignOut = () => {
    signOut();
    navigate('/signin', { replace: true });
  };

  const handleHelp = () => navigate('/help');
  const handleClientSearch = () => {
    if (globalSearchEnabled) navigate(GLOBAL_SEARCH_PATH);
    else if (coordinatorAdvancedOnly) navigate(`${GLOBAL_SEARCH_PATH}?mode=advanced`);
    else navigate(getLegacySearchPath(features));
  };
  const handleProfile = () => navigate('/profile');
  const handleNews = () => navigate('/news');

  return (
    <div className="status-container">
      {showLoggedIn ? (
        <div className="status-logged-in">
          <div className="lang-toggle" onClick={toggleLanguage}>
            <span className="language-text pill accent">{language.toUpperCase()}</span>
          </div>
          <div className="status-actions">
            <NotificationBell />
            <button className="pill icon-button" onClick={handleHelp} title={t('breadcrumb.help')} aria-label={t('breadcrumb.help')}>
              <FiHelpCircle />
            </button>
            <button className="pill icon-button" onClick={handleNews} title={t('breadcrumb.news')} aria-label={t('breadcrumb.news')}>
              <FiFileText />
            </button>
            <button
              className="pill icon-button"
              onClick={handleClientSearch}
              title={searchLabel}
              aria-label={searchLabel}
            >
              <FiSearch />
            </button>
            <button className="pill icon-button" onClick={handleProfile} title={t('profile.title')} aria-label={t('profile.title')}>
              <FiUser />
            </button>
          </div>
          <button className="login-button" onClick={handleSignOut}>{t('logout')}</button>
        </div>
      ) : (
        <div className="status-logged-in">
          <div className="lang-toggle" onClick={toggleLanguage}>
            <span className="language-text pill accent">{language.toUpperCase()}</span>
          </div>
          <button className="login-button" onClick={() => navigate('/signin')}>
            {t('login')}
          </button>
        </div>
      )}
    </div>
  );
};

export default Status;
